import { useEffect } from 'react';
import { useOpportunityDetailDrawerStore } from '../../stores/opportunity-detail-drawer-store';
import { OpportunityDetailView } from './OpportunityDetailView';

/**
 * Overlay-drawer voor opportunity-detail (Cinco-platform doorverwijzingen).
 * Globaal gemount in AppLayout, zodat de klantpagina-tab
 * `useOpportunityDetailDrawerStore.open(id)` kan aanroepen. Zelfde stacking-tier
 * en Escape-gedrag als de order-drawer (z-[55]/z-[60]).
 */
export function OpportunityDetailDrawerPanel() {
  const openOpportunityId = useOpportunityDetailDrawerStore((s) => s.openOpportunityId);
  const close = useOpportunityDetailDrawerStore((s) => s.close);

  useEffect(() => {
    if (!openOpportunityId) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      const t = e.target as HTMLElement | null;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT')) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      close();
    };
    window.addEventListener('keydown', handler, true);
    return () => window.removeEventListener('keydown', handler, true);
  }, [openOpportunityId, close]);

  if (!openOpportunityId) return null;

  return (
    <>
      <div className="fixed inset-0 bg-slate-900/30 z-[55]" onClick={close} aria-hidden />
      <aside
        className="fixed top-0 right-0 h-full w-full max-w-2xl bg-white shadow-2xl z-[60] flex flex-col"
        role="dialog"
        aria-modal="true"
        aria-label="Doorverwijzing detail"
      >
        <OpportunityDetailView
          key={openOpportunityId}
          id={openOpportunityId}
          variant="drawer"
          onClose={close}
        />
      </aside>
    </>
  );
}
